import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent, Input } from "@repo/ui";
import { Loader2 } from "lucide-react";

export default function SearchableDropdown({
  searchTerm,
  onSearchChange,
  onChange,
  placeholder = "Search...",
  data,
  loading = false,
  minChars = 5,
}) {
  const [open, setOpen] = useState(false);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center py-4">
          <Loader2 className="animate-spin h-4 w-4" />
        </div>
      );
    }

    if (data.length > 0) {
      return data.map((item) => (
        <button
          key={item.value}
          type="button"
          className="w-full text-left px-3 py-2 hover:bg-accent cursor-pointer text-sm"
          onClick={() => {
            onChange(item.value, item.label);
            onSearchChange(item.label);
            setOpen(false);
          }}
        >
          {item.label}
        </button>
      ));
    }

    return (
      <div className="px-3 py-2 text-sm">
        {searchTerm.length < minChars
          ? `Type at least ${minChars} characters`
          : "No results found"}
      </div>
    );
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="w-full">
          <Input
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => {
              onSearchChange(e.target.value);
              setOpen(true);
            }}
            onFocus={() => {
              setOpen(true);
            }}
            className="cursor-text w-full border rounded px-3 py-2 text-sm"
          />
        </div>
      </PopoverTrigger>

      <PopoverContent
        className="p-0 w-[--radix-popover-trigger-width] max-h-60 overflow-auto"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        onEscapeKeyDown={() => {
          setOpen(false);
        }}
        onPointerDownOutside={() => {
          setOpen(false);
        }}
      >
        {renderContent()}
      </PopoverContent>
    </Popover>
  );
}
